const Entry = resolve => require(['@/views/Entry'], resolve)
const LoginPage = resolve => require(['@/views/LoginPage'], resolve)
export default [
  {
    name: 'Entry',
    path: '/entry',
    component: Entry,
    meta: {
      keepAlive: false,
    },
  },
  {
    name: 'LoginPage,',
    path: '/loginPage',
    component: LoginPage,
    meta: {
      keepAlive: false,
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/entry.js